module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.hi("from view")) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd3a0b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SayHiFromMixin.vue
// module id = 71
// module chunks = 0